import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import GruposModal from '../components/GruposModal';
import ChatInternoModal from '../components/ChatInternoModal';
import { LightboxImagem } from './Atendimentos';
import { API, useAuth } from '../contexts/AuthContext';

// Grupos como TELA, não como janelinha por cima das Conversas — é uma das
// abas do rodapé, e aba que abre modal engana: some ao tocar fora, não guarda
// lugar no histórico e não deixa a aba acesa.
//
// A Equipe mora aqui dentro, destacada no topo da lista: é a mesma natureza de
// conversa (várias pessoas, fora da fila do cliente).
export default function Grupos() {
  const { temPermissao } = useAuth();
  const [dentroDeUmGrupo, setDentroDeUmGrupo] = useState(false);
  const [equipeAberta, setEquipeAberta] = useState(false);
  const [equipeNaoLidas, setEquipeNaoLidas] = useState(0);
  const [lightbox, setLightbox] = useState(null);

  const [largura, setLargura] = useState(() => window.innerWidth);
  useEffect(() => {
    const aoRedimensionar = () => setLargura(window.innerWidth);
    window.addEventListener('resize', aoRedimensionar);
    window.addEventListener('orientationchange', aoRedimensionar);
    return () => {
      window.removeEventListener('resize', aoRedimensionar);
      window.removeEventListener('orientationchange', aoRedimensionar);
    };
  }, []);
  const [toque] = useState(() => (typeof window !== 'undefined'
    && !!window.matchMedia?.('(pointer: coarse)').matches));
  // Mesma regra do Atendimentos.js e do index.css — as três têm que concordar.
  const isMobile = largura <= 768 || (toque && largura <= 1400);

  // Dentro de um grupo no toque, a tela é do WhatsApp: full-bleed, sem a barra
  // de abas em cima do campo de digitar.
  useEffect(() => {
    const imersivo = isMobile && dentroDeUmGrupo;
    document.body.classList.toggle('conversa-imersiva', imersivo);
    return () => document.body.classList.remove('conversa-imersiva');
  }, [isMobile, dentroDeUmGrupo]);

  // Badge da Equipe: o mesmo contador que a tela de Conversas mostra.
  const recarregarEquipe = useCallback(() => {
    axios.get(`${API}/chat-interno/nao-lidas`)
      .then((r) => setEquipeNaoLidas(Number(r.data?.data?.total || 0)))
      .catch(() => { /* badge é acessório: some, não quebra a tela */ });
  }, []);
  useEffect(() => {
    recarregarEquipe();
    const id = setInterval(recarregarEquipe, 15000);
    return () => clearInterval(id);
  }, [recarregarEquipe]);

  // Altura visível quando o teclado sobe (o iOS não encolhe o 100dvh sozinho).
  const [areaVisivel, setAreaVisivel] = useState(null);
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return undefined;
    const aoMudar = () => {
      const tecladoAberto = (window.innerHeight - vv.height) > 120;
      setAreaVisivel(tecladoAberto ? Math.round(vv.height) : null);
    };
    vv.addEventListener('resize', aoMudar);
    vv.addEventListener('scroll', aoMudar);
    return () => { vv.removeEventListener('resize', aoMudar); vv.removeEventListener('scroll', aoMudar); };
  }, []);

  if (!temPermissao('ti:atendimentos')) {
    return (
      <div className="content-shell">
        <div className="feedback-banner feedback-banner--error">
          Você não tem permissão para acessar grupos.
        </div>
      </div>
    );
  }

  const altura = isMobile
    ? (dentroDeUmGrupo
      ? (areaVisivel ? `${areaVisivel}px` : '100dvh')
      : 'calc(100dvh - 28px - var(--fio-abas-h) - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px))')
    : 'calc(100vh - 32px)';

  return (
    <div className="content-shell" style={{ height: altura, display: 'flex', flexDirection: 'column' }}>
      <GruposModal
        comoTela
        aberto
        onAtivoChange={(g) => setDentroDeUmGrupo(!!g)}
        onAbrirImagem={setLightbox}
        equipeNaoLidas={equipeNaoLidas}
        onAbrirEquipe={() => setEquipeAberta(true)}
      />

      <ChatInternoModal
        aberto={equipeAberta}
        onClose={() => { setEquipeAberta(false); recarregarEquipe(); }}
        onLido={recarregarEquipe}
      />

      <LightboxImagem url={lightbox} onClose={() => setLightbox(null)} />
    </div>
  );
}
